import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import Header from "./Header";
import UserViewMembershipApplicationComponent from "./ViewUserMemberApplication";
import Footer from "./Footer";
import { encryptSlug, decryptSlug } from "../../util/encryption";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import axios from "axios";
import { useSettings } from "./SettingsContext";
import {
  InsertMembersPaymentDetails
} from "../../components/UserMembershipApplication/Api/services/Webservices";
import Cookies from 'js-cookie';
const UserMemberApplicationPreview = () => {

  const useQuery = () => {return new URLSearchParams(useLocation().search)};      
  const query = useQuery();
  const { slug } = useParams();
  const history = useHistory();
  const decryptedId = decryptSlug(slug);
  const { razorpayKey } = useSettings();

  useEffect(() => {
    if (!window.Razorpay) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const createOrder = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/create_order`,
        { member_id: decryptedId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      // if (response.data.status) {
      return response.data;
      // } else {
      //   console.error("Error: Failed to fetch user data");
      //   return null;
      // }
    } 
    // catch (error) {
    //   console.error("Error fetching users data:", error);
    //   return null;
    // }
    catch (err) {
      console.error("Payment Error: ", err);  
      let message = "A network error occurred. Please try again later.";  
      if (err.response) {
        message =
          err.response.data?.message ||
          err.response.data?.error ||
          `Server error (${err.response.status})`;
      } else if (err.request) {
        message = "No response from server. Please check your internet connection.";
      } else {
        message = err.message || "Request failed";
      }  
      showToast(message, "error")
      return null;
    }
  };
  const capturePayment = async (paymentId, amount) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/verify_and_capture`,
        { 
          razorpay_payment_id: paymentId,
          amount
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      // if (response.data.status) {
      return response.data;
      // } else {
      //   console.error("Error: Failed to fetch user data");
      //   return null;
      // }
    }catch (err) {
      console.error("Payment Error: ", err);  
      let message = "A network error occurred. Please try again later.";  
      if (err.response) {
        message =
          err.response.data?.message ||
          err.response.data?.error ||
          `Server error (${err.response.status})`;
      } else if (err.request) {
        message = "No response from server. Please check your internet connection.";
      } else {
        message = err.message || "Request failed";
      }  
      showToast(message, "error")
      return null;
    }
  };
  // Handle payment
  const handlePayment = async ( applicationId ) => {
    try {
        console.log("applicationId", applicationId);
     const orderData = await createOrder();
     if (!orderData.id) {
       return;
     }
     const options = {
          key: razorpayKey,
          amount: orderData.amount,
          currency: orderData.currency,
          order_id: orderData.id,
          // name: memberDetails.,
          // description: "Test Payment",
          // prefill: { name: user.name, email: user.email, contact: user.contact },
          // theme: { color: "#F37254" },
          handler: async function (response) {
            console.log(
              `Payment Successful! Payment ID: ${response.razorpay_payment_id}`,
              response
            );
            const hasCapturedPayment = await capturePayment(orderData.id, orderData.amount);
            if (hasCapturedPayment) {
              console.log("Payment already completed for this order.",hasCapturedPayment);
              showToast("Payment already completed for this order.", "info");
            }
            const requestData = {
              id: decryptedId,
              amount: orderData.amount,
              currency: orderData.currency,
              payment_status: "Success",
              payment_id: `${response.razorpay_payment_id}`,
              payment_json: JSON.stringify(response),
              application_id: applicationId,
            };
            console.log(`Payment Successful! Request Data:`, requestData);
            InsertMembersPaymentDetails(requestData).then((res) => {
              if (res.status === true) {
                showToast(res.message, "success");
                history.push(
                  `${ROUTE_BASE_URL}/user-member-application-payment/${encryptSlug(`${res.application_no}`)}?id=${encryptSlug(`${applicationId}`)}`
                );
              } else {
                showToast(res.message, "error");
              }
            }).catch((error) => {
              console.error("Error Payment Successful! Request:", error);
              showToast(error.message || "Something went wrong. Please try again.", "error");
            });
          },

          modal: {
            ondismiss: function () {
              console.log("Payment popup closed");
              const requestData = {
                id: decryptedId,
                amount: orderData.amount,
                currency: orderData.currency,
                payment_status: "Failed",
                payment_id: "",
                payment_json: "",
                application_id: applicationId,
              };
              console.log(`Payment Successful! Failed Data:`, requestData);
              InsertMembersPaymentDetails(requestData)
              .then((res) => {
                if (res.status === true) {
                  showToast(res.message, "success");
                  history.push(
                    `${ROUTE_BASE_URL}/user-member-application-payment-failed/${encryptSlug(`${res.application_no}`)}`
                  );
                } else {
                  showToast(res.message, "error");
                }
              })
              .catch((error) => {
                console.error("Error Payment Successful! Request:", error);
                showToast(error.message || "Something went wrong. Please try again.", "error");
            });
           }
          },
          retry: {
            enabled: true,
            max_count: 3,
          },
     }; 
     if (!window.Razorpay) {
       console.log("Razorpay SDK failed to load. Are you online?");
       return;
     }
     const razorpayInstance = new window.Razorpay(options);
     razorpayInstance.open();
    }catch (err) {
      console.error("Payment Error: ", err);  
      let message = "A network error occurred. Please try again later.";  
      if (err.response) {
        message =
          err.response.data?.message ||
          err.response.data?.error ||
          `Server error (${err.response.status})`;
      } else if (err.request) {
        message = "No response from server. Please check your internet connection.";
      } else {
        message = err.message || "Request failed";
      }  
      showToast(message, "error")
    }
  };

  const fetchProfileMenuDetails = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/check_user_data`,
        {
          username: query.get("email")
        },
        {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        const user = response.data.data[0];
        const eventUser = response.data.event_data[0];
        const isMember= response.data.member;
        const isEventMember= response.data.event;
        localStorage.setItem('isMember', isMember);
        localStorage.setItem("isEventMember", isEventMember);
        if(isEventMember===1){ 
            // Store user details
            // Cookies.set("eventMemberUserId", response.data.event_data[0].id, { expires: 1 });
            localStorage.setItem("loginEventMemberUserId", response.data.event_data[0].id);
            const fullName = `${eventUser.first_name}${eventUser.last_name ? ' ' + eventUser.last_name : ''}`;
            localStorage.setItem('loginMemberUserName', fullName);
            localStorage.setItem("loginEventMemberEmail", eventUser.email);
        }
        if(isMember===1){
          Cookies.set("memberUserId", response.data.data[0].id, { expires: 1 });
          localStorage.setItem("loginMemberUserId", response.data.data[0].id);
          const fullName = `${user.first_name}${user.last_name ? ' ' + user.last_name : ''}`;
          localStorage.setItem('loginMemberUserName', fullName);
          localStorage.setItem("loginEventMemberEmail", user.email);
        }
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };
  useEffect(() => {
    if(query.get("email")!==null){fetchProfileMenuDetails();}    
  }, []);
return (
    <>    
        <section className="user_div_total">
            <Header/>
            <div className="container pt-50">
                <div className="row">
                    <div className="col-md-12">
                    
                        <UserViewMembershipApplicationComponent
                            page={"preview"} 
                            memberId={decryptedId}
                            //   handlePrevTab={handlePrevTab}
                            handlePayment={handlePayment}
                        />
                    </div>
                </div>
            </div>
            <Footer/>
        </section>
    </>
);

}


export default UserMemberApplicationPreview
